import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { mainTheme } from '@ankr.com/ui';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import BigNumber from 'bignumber.js';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import { useIsInitializedLocale } from 'modules/i18n';
import { Routes } from 'modules/routes';
import { store } from 'modules/store';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';

import packageJSON from '../package.json';

BigNumber.config({ EXPONENTIAL_AT: [-100, 100], DECIMAL_PLACES: 18 });

export function App(): JSX.Element {
  const isInitialized = useIsInitializedLocale();

  return (
    <Provider store={store}>
      <ThemeProvider theme={mainTheme}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Router basename={packageJSON.homepage}>
            <QueryParamProvider adapter={ReactRouter6Adapter}>
              <CssBaseline />

              {isInitialized && <Routes />}
            </QueryParamProvider>
          </Router>
        </LocalizationProvider>
      </ThemeProvider>
    </Provider>
  );
}
